import flash from '../util/flashFunction';
import trans from '../util/transFunction';
import route from '../util/routeFunction';
import debounce from 'debounce';

Vue.prototype.debounce = debounce;
Vue.prototype.flash = flash;
Vue.prototype.trans = trans;
Vue.prototype.route = route;

window.debounce = debounce;
window.sw3.flash = flash;
window.sw3.trans = trans;
window.sw3.route = route;

/**
 * Returns old values
 *
 * Usage:
 * old(): Returns array of all old values
 * old('name'): Returns old value of name or empty string
 * old('name', 'Max'): Returns old value of name or Max if empty
 */
Vue.prototype.old = (value = null, returnWhenEmpty = '') => {

    if(!value) {
        return window.sw3.oldValues;
    }

    return window.sw3.oldValues[value] ? window.sw3.oldValues[value] : returnWhenEmpty;

}
window.sw3.old = Vue.prototype.old;

/**
 * Returns validation error(s), assumes "default" bag
 *
 * Usage:
 * errors() : returns default bag as array or empty array
 * errors('name') : returns string of errors or separated by comma or empty string
 */
Vue.prototype.errors = (nameOfTheError = null) => {

    var defaultErrorBag = window.sw3.validationErrors['default'];
    var thereAreErrors = !!defaultErrorBag;

    if(!nameOfTheError) {
        return defaultErrorBag ? defaultErrorBag : [];
    }

    if(thereAreErrors) {
        return defaultErrorBag[nameOfTheError] ? defaultErrorBag[nameOfTheError].join(', ') : '';
    }

    return '';
}
window.sw3.old = Vue.prototype.old;

const currentUser = {
    ...window.sw3.user,
    isAdmin : () => { return window.sw3.user.roles_id.includes(1); },
    isClientAdmin : () => { return window.sw3.user.roles_id.includes(5); },
    can : (attribute) => {
        return window.sw3.user.can[attribute];
    }
}

Vue.prototype.currentUser = currentUser
Vue.prototype.user = () => window.sw3.user;
Vue.prototype.auth = () => window.sw3.user;

Vue.prototype.csrf_token = () => window.sw3.csrfToken;
Vue.prototype.csrfToken = () => window.sw3.csrfToken;
Vue.prototype.csrf = () => window.sw3.csrfToken;
